import React from 'react';
import {
  Card, Divider,
} from 'antd';
import PropTypes from 'prop-types';
import { Box, Text } from '../../../shared/components';
import CabeceraEncargo from '../../containers/creador/CabeceraEncargo.dataentry';
import DetallesEncargo from '../../containers/creador/DetallesEncargo.dataentry';
import { encargoCreacionType } from '../../types/encargo.creacion.types';

export default function EncargoCard(props) {
  const { encargo, onClickSeleccionarCliente, modo } = props;
  if (encargo === undefined || encargo === null) {
    return (
      <Box>
        <Text>Sin encargo inicializado</Text>
      </Box>
    );
  }
  const {
    uuid, pack, cabecera, cabecera: { cliente, observaciones }, nombre: nombreEncargo, expandido,
    erroresFormulario,
  } = encargo;
  if (cliente === undefined || cliente === null) {
    return (
      <Box>
        <Text>Sin cliente inicializado</Text>
      </Box>
    );
  }

  const { id: idCliente, graduaciones } = cliente;
  const esEncargoSimple = pack === undefined || pack === null;
  const tieneClienteSeleccionado = idCliente !== undefined && idCliente !== null;
  return (
    <Box>
      <Card>
        <CabeceraEncargo
          modo={modo}
          onClickSeleccionarCliente={onClickSeleccionarCliente}
          encargoUUID={uuid}
          cabecera={cabecera}
          nombreEncargo={nombreEncargo}
          expandido={true}
          erroresFormulario={erroresFormulario}
        />
        <Divider style={{ margin: '0 0 16px 0' }} />
        <DetallesEncargo modo={modo} encargo={encargo} />
      </Card>
    </Box>
  );
}

EncargoCard.propTypes = {
  encargo: encargoCreacionType.isRequired,
  modo: PropTypes.string.isRequired,
  onClickSeleccionarCliente: PropTypes.func,
};

EncargoCard.defaultProps = {
  onClickSeleccionarCliente: () => {},
};
